module.exports = __webpack_public_path__ + "static/media/5.283158a2.png";